import React from 'react';
import { ImageLoader, ImageLoaderProps } from './ImageLoader';

export const LazyImageLoader: React.FC<ImageLoaderProps> = (props) => <ImageLoader {...props} lazy={true} />;

export default LazyImageLoader;
